import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Row, Button, ToggleButton, ToggleButtonGroup, Col,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import { PROJECT_PREFIX } from '../const';

export default class PollScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data: {} };
        this.handleChange = this.handleChange.bind(this);

        this.API_ENDPOINT = 'poll/?';
        this.API_ENDPOINT_QS = '';
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    columns = [
        {
            Header: 'ID',
            accessor: 'id',
            maxWidth: 200,
            Cell: (row) => (
                <div align="center">
                    [poll]
                    {row.value}
                    [/poll]
                </div>
            ),
        },
        {
            Header: 'Заголовок',
            accessor: 'title',
            minWidth: 430,
            Cell: (row) => (
                <div>
                    <Link
                        to={`${PROJECT_PREFIX}/poll/${row.row.id}/edit`}
                    >
                        {row.value}
                    </Link>
                </div>
            ),
        }, {
            Header: '',
            accessor: 'id',
            maxWidth: 40,
            Cell: (row) => (
                <Button size="sm" variant="link" id={row.value} data-name={row.original.name} to="#" onClick={this.removeItemHandler}>
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>
            ),
        },
    ];

    pageChangeHandler = (data) => {
        this.props.history.push(`${PROJECT_PREFIX}/${data}/all`);
    };

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/poll/new" />
                    </Col>
                </Row>
                <Row>
                    <ToggleButtonGroup
                        value="poll"
                        name="pageType"
                        key="inlineStyleBlock"
                        type="radio"
                        onChange={this.pageChangeHandler}
                    >
                        <ToggleButton variant="outline-secondary" value="quiz_trivia"> Викторины </ToggleButton>
                        <ToggleButton variant="outline-secondary" value="quiz"> Тесты </ToggleButton>
                        <ToggleButton variant="outline-secondary" value="poll"> Опросы </ToggleButton>
                    </ToggleButtonGroup>
                </Row>
                <Row>
                    <TableScreenWithoutUpdate
                        columns={this.columns}
                        endpoint={this.API_ENDPOINT + this.API_ENDPOINT_QS}
                    />
                </Row>
            </div>
        );
    }
}
